// extracted by mini-css-extract-plugin
export var breadcrumb = "_y-2";
export var breadcrumbArrow = "_y-3";
export var breadcrumbs = "_y-0";
export var link = "_y-4";
export var small = "_y-1";